import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuNavigationContext } from './menuNavigationContext';

const useMenuNavigation = () => {
  const navigateFromMenu = useContext(MenuNavigationContext);
  const navigate = useNavigate();

  return useCallback(
    (link: string) => {
      if (navigateFromMenu) {
        navigateFromMenu(link);
        return;
      }

      navigate(link);
    },
    [navigate, navigateFromMenu]
  );
};

export { useMenuNavigation };
